// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import Icon from 'app/common/components/Icon';
import Keydown from 'app/common/components/Keydown';
import KindPropType from 'app/common/KindPropType';
import TextInput from 'app/common/components/TextInput';
import 'app/common/components/SearchBox.scss';

const bem = bemify('search-box');

const SearchBox = createReactClass({
  displayName: 'SearchBox',
  keydownHandlers: (null: ?any),

  propTypes: {
    name: PropTypes.string,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    inputRef: PropTypes.any,
    className: PropTypes.string,
    kind: KindPropType,
    renderIcon: PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      placeholder: 'Search…',
      onReset: () => {},
      renderIcon: () => (
        <Icon
          className={bem('__search-icon')}
          onClick={this.onSubmit}
          type="search"
        />
      ),
    };
  },

  UNSAFE_componentWillMount() {
    const { onSubmit } = this.props;
    const killEvent = {
      stopPropagation: true,
      preventDefault: true,
    };
    this.keydownHandlers = {
      escape: { handler: this.onReset, ...killEvent },
      ...(onSubmit ? { enter: { handler: this.onSubmit, ...killEvent } } : {}),
    };
  },

  onReset() {
    const { name, value, onReset } = this.props;
    onReset(value, name);
  },

  onSubmit() {
    const { name, value, onSubmit } = this.props;
    if (onSubmit) {
      onSubmit(value, name);
    }
  },

  render() {
    const { props } = this;
    const className = bem(toModifiers(props.kind), props.className);

    const resetIcon =
      (props.value || '').length === 0 ? null : (
        <span className={bem('__icon --after')}>
          <Icon
            className={bem('__clear-icon')}
            onClick={this.onReset}
            type="delete"
          />
        </span>
      );

    // By default, it renders a search icon, but can be customized
    const beforeIcon = (
      <span className={bem('__icon --before')}>{props.renderIcon(props)}</span>
    );

    return (
      <Keydown handlers={this.keydownHandlers}>
        <div className={className}>
          {beforeIcon}
          <TextInput
            {..._.omit(props, 'renderIcon')}
            className={bem('__input')}
          />
          {resetIcon}
        </div>
      </Keydown>
    );
  },
});

export default SearchBox;
